// extracted by mini-css-extract-plugin
export default {"SignUpTitle":"iStyles_SignUpTitle__BOM4j","SignUpSubtitle":"iStyles_SignUpSubtitle__bNDNt"};